import React, { useState } from 'react';
import ProcessSheetList from './ProcessSheetList';
import ProcessSheetCreate from './ProcessSheetCreate';
import { HelmetAsync } from '../../utils/HelmetAsync';

const ProcessSheetPage = () => {
    // view: 'list' | 'create' | 'edit'
    const [view, setView]               = useState('list');
    const [editingSheet, setEditingSheet] = useState(null);

    const handleEdit = (sheet) => {
        setEditingSheet(sheet);
        setView('edit');
    };

    const handleBack = () => {
        setView('list');
        setEditingSheet(null);
    };

    return (
        <>
            <HelmetAsync title="Process Sheets – BreyERP" />
            <div className="p-4 md:p-6">
                {view === 'list' && (
                    <ProcessSheetList
                        onCreateNew={() => setView('create')}
                        onEdit={handleEdit}
                    />
                )}
                {view === 'create' && (
                    <ProcessSheetCreate
                        onBack={handleBack}
                        existingSheet={null}
                    />
                )}
                {view === 'edit' && (
                    <ProcessSheetCreate
                        onBack={handleBack}
                        existingSheet={editingSheet}
                    />
                )}
            </div>
        </>
    );
};

export default ProcessSheetPage;